interface RestoreFileProps {
  width?: string;
  height?: string;
}

function RestoreFile({ width = '34', height = '34' }: RestoreFileProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 3.75C0 1.68164 1.68164 0 3.75 0H13.125V7.5C13.125 8.53711 13.9629 9.375 15 9.375H22.5V11.6367C18.1699 12.8613 15 16.8398 15 21.5625C15 25.0254 16.7051 28.084 19.3184 29.959C19.1309 29.9883 18.9434 30 18.75 30H3.75C1.68164 30 0 28.3184 0 26.25V3.75ZM22.5 7.5H15V0L22.5 7.5ZM25.3125 13.125C28.908 13.125 31.875 16.092 31.875 19.6875C31.875 21.9524 30.5547 24.0449 28.5703 25.2906L28.5703 23.7969C28.5703 23.3438 28.0195 23.0625 27.6445 23.3789L24.75 25.8906C24.4219 26.1641 24.4219 26.6641 24.75 26.9375L27.6445 29.4492C28.0195 29.7656 28.5703 29.4844 28.5703 29.0312V27.5059C31.0781 25.9297 32.875 23.0078 32.875 19.6875C32.875 15.1934 29.5566 11.875 25.0625 11.875C22.4609 11.875 20.1416 13.2012 18.8359 15.1924C18.6133 15.5488 18.7363 16.0117 19.1289 16.1523C19.5215 16.293 19.9668 16.0508 20.1875 15.7109C21.1719 14.1875 23.0781 13.125 25.3125 13.125Z" />
    </svg>
  );
}

export default RestoreFile;
